<template>
  <!-- template for the modal component -->
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper" style="height:100vh;">
        <div class="modal-container betSlipContainer text-center"
          :style="$vuetify.theme.dark ? 'background:#232D3F;margin-top:-280px' : 'background:white;margin-top:-280px'">
          <v-btn elevation="0" fab color="error" small class="modal-default-button title" @click="$emit('close')">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <div style="clear:both"></div>
          <div class="title primary--text mb-3">Scan Player Card</div>
          <v-progress-linear indeterminate color="primary"></v-progress-linear>
          <v-textarea height="90px" class="mt-5" color="teal" autofocus v-model="playerCard"
            @click="showShowManualEntry()">
            <template v-slot:label>
              <div>
                When entering manually do not include dashes
              </div>
            </template>
          </v-textarea>
          <v-btn elevation="0" dark x-large class="processTicketButton mb-15" @click="enterPlayerCard(playerCard)"
            color="#60697E" :disabled="loadCircle || !playerCard">
            <span v-if="!loadCircle" class="display-1">Enter Card</span>
            <v-progress-circular v-if="loadCircle" indeterminate color="primary">
            </v-progress-circular>
          </v-btn>
        </div>
      </div>
      <div v-if="showKeyboard" style="width:100vw;position:absolute;left:0;bottom:0">
        <SimpleKeyboardAMT @onChange="onChange" :input="playerCard" />
      </div>
    </div>
  </transition>

  <!-- app -->
</template>

<script>

import SimpleKeyboardAMT from "./SimpleKeyboardAMT"

export default {
  name: 'PlayerCardModal',
  data() {
    return {
      loadCircle: false,
      playerCard: null,
      showKeyboard: false,
      isReaderScan: false,
    }
  },
  props: {
    onPlayerCardEntered: Function
  },
  created() {
    // Add barcode scan listener and pass the callback function
    if (window.rt?.onMagCardEvent) {
      window.rt.onMagCardEvent((msg) => {
        const tracks = JSON.parse(msg)
        this.onPlayerCardEntered(tracks[1]);
      });
      this.ticketScanHandler = window.rt.onTicketScanEvent((scan) => {
        this.isReaderScan = true;
        this.onPlayerCardEntered(scan);
      });
    }
  },
  // destroyed () {
  //   // Remove listener when component is destroyed
  //   this.$barcodeScanner.destroy()
  //   if (window.rt?.clearOnTicketScanEventHandlers) {
  //     window.rt.removeTicketScanEventHandler(this.ticketScanHandler);
  //   }
  // },
  components: {
    SimpleKeyboardAMT
  },
  methods: {
    showShowManualEntry() {
      this.showKeyboard = true
    },
    onChange(playerCard) {
      this.playerCard = playerCard
    },
    enterPlayerCard(v) {
      const playerId = v
      this.onPlayerCardEntered(playerId)
    }
  }
}
</script>

<style>
.processTicketButton {
  border-radius: 8px;
  background-color: #4caf50;
  width: 100%;
  padding: 12px;
  color: #fff;
  font-size: 1.8em;
  text-align: center;
  bottom: -50px;
  z-index: 200;
  position: relative;
  font-weight: 600;
  cursor: pointer;
}

.addMultiButton {
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.5);
  background-color: #ffffff;
  font-size: 1.1em;
  color: #333;
  width: 100%;
  padding: 10px;
  margin-top: 50px;
  text-align: center;
}

.unitStake {
  border: 1px solid #666;
  width: 100%;
  padding: 5px;
  font-size: 1.2em;
  font-weight: 500;
  background: #e6faff;
  color: #666;
  height: 1.8em;
  margin-top: 50px;
}

.betPriceButton {
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.5);
  background-color: #ffffff;
  height: 3em;
  width: 17%;
  font-size: 1em;
  padding: 5px;
  text-align: center;
  margin: 7px 0 0 7px;
  line-height: 2.5em;
  font-weight: 600;
  color: #333;
  cursor: pointer;
}

.removeBorder {
  box-shadow: none;
  background-color: #ffffff;
  height: 3em;
  width: 18%;
  padding: 5px;
  text-align: center;
  margin: 5px 0 0 5px;
}

.modal-icon {
  margin-top: -80px;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 350px;
  margin: 0px auto;
  padding: 20px 30px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.betPriceButtonClear {
  background-color: #ffffff;
  height: 3em;
  width: 17%;
  font-size: 0.9em;
  padding: 5px;
  text-align: center;
  margin: 7px 0 0 7px;
  line-height: 2.5em;
  font-weight: 600;
  color: #333;
}

@media only screen and (max-width: 600px) {
  .modal-container {
    width: 90%;
    margin: 0px auto;
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
    font-family: Helvetica, Arial, sans-serif;
  }

  .betPriceButton {
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.5);
    background-color: #ffffff;
    height: 3em;
    width: 17%;
    font-size: 0.8em;
    padding: 5px;
    text-align: center;
    margin: 7px 0 0 7px;
    line-height: 2.5em;
    font-weight: 600;
    color: #333;
  }

  .betPriceButtonClear {
    background-color: #ffffff;
    height: 3em;
    width: 17%;
    font-size: 0.7em;
    padding: 5px;
    text-align: center;
    margin: 7px 0 0 7px;
    line-height: 2.5em;
    font-weight: 600;
    color: #333;
  }

  .modal-default-button {
    display: inline-block;
  }

  .raceTypeIconSlip {
    height: 80px;
    width: 80px;
    border-radius: 80px;
    background: #fff;
    margin: 0 auto;
    top: -80px;
    z-index: 200;
    position: relative;
    border: 6px solid #000;
    text-align: center;
  }
}

.raceTypeIconSlip {
  height: 80px;
  width: 80px;
  border-radius: 80px;
  background: #fff;
  margin: 0 auto;
  top: -60px;
  z-index: 200;
  position: relative;
  border: 6px solid #000;
  text-align: center;
}

.modal-default-button {
  float: left;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}</style>
